import React from "react";
import { Link } from "react-router-dom";

interface IButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
  shape?: "slim";
  active?: boolean;
  type?: "primary" | "secondary" | "alert" | "success" | "info";
  link?: boolean,
  to?: string
}

const Button = (props: IButtonProps) => {
  const { 
    children, 
    onClick, 
    className = "", 
    disabled = false, 
    shape = "default", 
    active = true, 
    type = "primary",
    link = false,
    to = "/"
  } = props;

  const mainStyle = ` ml-auto h-10 flex items-center justify-center rounded-[4px] font-bold text-sm no-underline transition-colors duration-300 ease-in-out `;

  const buttonStylePrimary = ` 
    ${shape === "slim" ? "px-0 w-8" : "px-3"}
    ${mainStyle}
    ${active ? 
      "bg-primary text-white hover:bg-primary-dark hover:text-[#ccc0ba]" 
      : "bg-white text-gray-400 hover:text-gray-500 hover:bg-gray-100"
    }
  `;

  const buttonStyleSecondary = ` 
    ${shape === "slim" ? "px-0 w-8" : "px-3"}
    ${mainStyle}
    ${active ? 
      "bg-[#edf1f4] hover:bg-[#bec1c3]" 
      : "bg-white text-gray-400 hover:text-gray-500 hover:bg-gray-100"
    }
  `;

  const buttonStylePrimaryLoading = `
    ${shape === "slim" ? "px-0 w-8" : "px-3"}
    ${mainStyle}
    bg-gray-300 text-black hover:bg-gray-400 cursor-not-allowed
  `;

  const buttonAlertStyle = `
    px-3
    ${mainStyle}
    bg-red-500 text-white hover:bg-red-600 hover:text-[#ccc0ba]
  `;

  const buttonSuccessStyle = `
    px-3
    ${mainStyle}
    bg-emerald-600 text-white hover:bg-emerald-700 hover:text-[#ccc0ba]
  `;

  const buttonInfoStyle = `
    px-3
    ${mainStyle}
    bg-secondary text-white hover:bg-secondary-dark hover:text-[#ccc0ba]
  `;

  // const buttonStyle = (type === "secondary" ? buttonStyleSecondary : buttonStylePrimary);

  const buttonStyle = (
    type === "success"
    ? buttonSuccessStyle
    : type === "alert"
    ? buttonAlertStyle
    : type === "secondary" 
    ? buttonStyleSecondary 
    : type === "info"
    ? buttonInfoStyle
    : type === "primary" && disabled && shape !== "slim" // let slim disabled still be primary (just disabled)
    ? buttonStylePrimaryLoading
    : buttonStylePrimary
  );

  if (link) {
    return (
      <div>
        <Link to={to}
          onClick={onClick} 
          className={className + buttonStyle}
        >
          {children}
        </Link>
      </div>
    )
  }

  return (
    <div>
      <button 
        disabled={disabled}
        onClick={onClick} 
        className={className + buttonStyle}
      >
        {children}
      </button>
    </div>
  )
};



export {
  Button
};